import { GET_FIELD_REGISTRY, GET_FIELD_REGISTRY_SUCCESS, GET_FIELD_REGISTRY_ERROR, GET_FIELD_REGISTRY_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetFieldRegistry = (state = initialState, action) => {
  switch (action.type) {
    case GET_FIELD_REGISTRY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_FIELD_REGISTRY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_FIELD_REGISTRY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_FIELD_REGISTRY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetFieldRegistry;
